import React from 'react';

const INVESTOR_POINTS = [
    'Simple but sophisticated deal management platform – FREE',
    'Triaging of inbound applications from your web site within 4 minutes',
    'Automated diligence tools – corporate, legal, financial, software tech',
    'Or, connect your own',
    'Can integrate into existing workflows e.g. Hubspot',
    'Ongoing portfolio management tools – at a glance window into each investment',
];

const COMPANY_POINTS = [
    'Our 200 agents help you automate transaction readiness in days',
    'Comprehensive diligence pack',
    'Reverse diligence using the same VC tools',
    'Certify bronze, silver gold',
    'Always deal-ready for follow on rounds and exit',
];

const ArrowDown = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="#F5A623" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M12 4v14M6 12l6 6 6-6" /></svg>
);

// Connector pointing from the right-hand panel back into the left one.
const ArrowLeft = ({ variant }) => (
    <span className={`lp-vc-arrow lp-vc-arrow--${variant}`} aria-hidden="true">
        <svg viewBox="0 0 110 8" preserveAspectRatio="none" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M110 4 L14 4" />
            <path d="M22 -6 L10 4 L22 14" />
        </svg>
    </span>
);

const Panel = ({ variant, title, points, plus }) => (
    <div className={`lp-vc-panel lp-vc-panel--${variant}`}>
        <h3>{title}</h3>
        <div className="pts">
            {points.map(p => <p className='w100' key={p}>— {p}</p>)}
        </div>
        <div className="plus">
            <span className="dot" />
            <p>{plus}</p>
            <ArrowDown />
        </div>
    </div>
);

// Value proposition per audience — problem first, then the benefit.
const AUDIENCES = [
    {
        tag: 'For companies',
        tagBg: '#EEF1FF',
        tagColor: '#4A67FF',
        title: 'Get transaction-ready',
        problem: 'Poorly prepared companies get rejected fast. Fewer expressions of interest. Delayed transactions. Price chipping.',
        benefit: 'Get organised quickly, at low cost. Build your diligence pack, connect to 50+ investors on our platform, and stay ready for every future round.',
    },
    {
        tag: 'For investors',
        tagBg: '#E4F7EE',
        tagColor: '#1F8A5B',
        title: 'Smarter deal flow',
        problem: "AI now lets investors see a target's full digital picture — not just curated files. Ignore it and you're deciding blind.",
        benefit: 'Free triaging in 3–4 minutes. Free deal management platform incorporating Corporate/financial/software diligence. Deeper insights, sharper decisions, better portfolio returns.',
    },
    {
        tag: 'For advisors',
        tagBg: '#F0EBFF',
        tagColor: '#6B4FD8',
        title: 'Serve more clients, better',
        problem: 'Clients expect you to use the best AI tools. You should be.',
        benefit: 'One platform, free to you. Serve all your clients, increase margins, and become the AI conductor that drives their results.',
    },
];

const HomeWhatWeDo = () => (
    <section className="lp-vc-sec">
        <div className="lp-vc-inner">
            <div className="lp-badge lp-badge--up lp-vc-eyebrow" data-lp-reveal><span />What we do</div>
            <h2 className="lp-h2 lp-vc-head" data-lp-reveal data-lp-delay="60">Value creation solutions for all parties in a transaction</h2>

            <div className="lp-vc-panels-wrap" data-lp-reveal data-lp-delay="120">
                <div className="lp-vc-panels">
                    <Panel variant="investors" title="For Investors & Purchasers" points={INVESTOR_POINTS} plus="Plus - Dealflow" />
                    <Panel variant="companies" title="For Companies & Advisors" points={COMPANY_POINTS} plus="Plus – Investormatching" />
                </div>
                <ArrowLeft variant="one" />
                <ArrowLeft variant="two" />

                {/* Gold banner overlaps the foot of both panels, tying the two "Plus" callouts together. */}
                <div className="lp-vc-gold">
                    <span className="dot" />
                    <p>Gold? 1-click investormatch to our investors – pre-qualified, pre-diligenced <span className="sub">— unlocked by Dealflow + Investormatching, above</span></p>
                </div>
            </div>

            <div className="lp-vc-bars" data-lp-reveal data-lp-delay="180">
                <div className="lp-vc-bar lp-vc-bar--dark">
                    <p>
                        <svg viewBox="0 0 24 24" fill="none" stroke="#4A67FF" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M13 2 3 14h7l-1 8 11-14h-7l1-6z" /></svg>
                        Our differentiator? A single integrated platform for all stakeholders over the company lifecycle
                    </p>
                </div>
                <div className="lp-vc-bar lp-vc-bar--light">
                    {/* Design breaks after "higher valuations" onto a second line. */}
                    <p>The benefits – quicker deals, less cost, expedited follow-on rounds, <span className="lp-accent">higher valuations</span><br />— a better outcome for everyone</p>
                </div>
            </div>
        </div>
    </section>
);

export default HomeWhatWeDo;
